export const LocalStorageTokenKey = '_token';
export const LocalStorageTokenEncryptKey = '_token';
export const LocalDeviceIdKey = 'USER_HARD_WARE_INFO';
export const LocalUuidKey = 'UNIQUE_USER_ID';
export const LocalStorageAnonymousUserID = 'ANONYMOUS_USER_ID';
export const LocalStorageAnonymousRealUserID = 'ANONYMOUS_REAL_USER_ID';

export const ShowBubbleKeys = 'SHOW_BUBBLE_KEYS';
export const LocalOpenIdKey = 'OPENID';
export const LocalUnionIDKey = 'UNION_ID';
export const LocalStorageShowLoginModal = 'SHOW_LOGIN_MODAL';
export const NATIVE_NETWORK_PUBLIC_PARAMS = 'NATIVE_NETWORK_PUBLIC_PARAMS';
export const NATIVE_NETWORK_PUBLIC_HEADER = 'NATIVE_NETWORK_PUBLIC_HEADER';

export const SUG_INFO = 'SUG_INFO';
